<template>
  <div>
    <details-modal
      :show="modals.profile"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="profile.category" type="text" label="Catégorie" />
        <fg-input v-model="profile.name" type="text" label="Nom" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchProfiles"
          title="Thèmes"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column
            label="Catégorie"
            min-width="20"
            property="category"
          />
          <el-table-column label="Nom" min-width="20" property="name" />
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        profile: false,
      },
      currentOperation: {},
      profile: {},
      errorMessage: ' ',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.profile = { ...row };
      this.modals.profile = true;
    },
    fetchProfiles(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/profileEntities/search/fulltext?projection=profileDTO&sort=profileCategory&sort=profileName&category=${searchText}&name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/profileEntities?projection=profileDTO&sort=profileCategory&sort=profileName&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.profileEntities
          ? response.data._embedded.profileEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/profiles/${this.profile.id}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.profile = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecord() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/profiles/${this.profile.id}`,
          {
            category: this.profile.category,
            name: this.profile.name,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.profile = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/profiles/`, {
          category: this.profile.category,
          name: this.profile.name,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.profile = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.profile = {};
      this.currentOperation = 'create';
      this.modals.profile = true;
    },
    closeModal() {
      this.modals.profile = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
